.page {
  background: #fafaf8;
  color: var(--yo-ink);
}
.layout {
  max-width: 1180px;
  margin: auto;
  padding: 52px 28px 104px;
  display: grid;
  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);
  grid-template-rows: auto 1fr;
  align-items: start;
  column-gap: clamp(32px, 6vw, 88px);
  row-gap: 28px;
}
.intro {
  padding-top: 16px;
}
.eyebrow {
  margin: 0;
  font: 600 12px / 1.7 var(--font-en);
  color: var(--yo-muted);
  letter-spacing: 0.12em;
}
.intro h1 {
  width: fit-content;
  margin: 14px 0 20px;
  font-size: clamp(32px, 3.8vw, 48px);
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.05em;
  text-wrap: balance;
}
.description {
  font-size: 15px;
  line-height: 2;
  color: var(--yo-ink-2);
}
.alternative {
  margin-top: 32px;
}
.alternative p {
  font-size: 13px;
  color: var(--yo-muted);
  margin-bottom: 8px;
}
.textLink {
  display: inline-flex;
  min-height: 44px;
  gap: 12px;
  align-items: center;
  padding: 8px 0;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  text-underline-offset: 5px;
  cursor: pointer;
}
.form,
.success {
  min-width: 0;
  padding: clamp(24px, 3vw, 40px);
  border-radius: var(--yo-radius);
  background: #fff;
}
.formHead {
  margin-bottom: 28px;
}
.formHead h2 {
  margin: 0 0 10px;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.6;
}
.formHead p,
.help {
  margin: 8px 0 0;
  color: var(--yo-muted);
  font-size: 12px;
  line-height: 1.8;
}
.fields {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
  display: grid;
  gap: 24px;
}
.serviceFields {
  border: 0;
  min-width: 0;
  margin: 0;
  padding: 0;
}
.serviceFields legend,
.field > label {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.8;
}
.required,
.optional {
  margin-left: 8px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}
.required {
  color: #a52821;
}
.optional {
  color: var(--yo-muted);
}
.fieldHelp {
  margin: 8px 0 0;
  color: var(--yo-muted);
  font-size: 12px;
  line-height: 1.8;
  overflow-wrap: anywhere;
}
.choices {
  display: grid;
  gap: 8px;
  margin-top: 14px;
}
.choice {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #deded8;
  border-radius: var(--yo-radius);
  cursor: pointer;
}
.choice:has(:checked) {
  border-color: var(--yo-ink);
  background: #fffce6;
}
.choice:has(:disabled) {
  background: #f7f7f5;
  color: #77746e;
  cursor: default;
}
.choice input,
.consent input {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  accent-color: var(--yo-ink);
}
.choice span {
  font-size: 14px;
  font-weight: 600;
}
.choice small {
  display: block;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.7;
  color: var(--yo-muted);
}
.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.field input,
.field textarea,
.field select {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #bfbfba;
  border-radius: var(--yo-radius);
  font: inherit;
  font-size: 16px;
  line-height: 1.6;
  background: #fff;
}
.page .field :is(input, textarea, select):focus {
  outline: none;
  outline-offset: 0;
}
.field :is(input, textarea, select):focus:not([aria-invalid="true"]) {
  border-color: var(--yo-ink);
}
.field textarea {
  min-height: 128px;
  resize: vertical;
}
.field input::placeholder,
.field textarea::placeholder {
  color: #7a7771;
  font-size: 14px;
}
.field [aria-invalid="true"] {
  border-color: #ab2920;
}
.fieldError {
  color: #ab2920;
  font-size: 13px;
  line-height: 1.7;
  margin: 4px 0 0;
}
.consent {
  display: flex;
  min-height: 44px;
  padding-block: 8px;
  align-items: flex-start;
  gap: 10px;
  font-size: 12px;
  line-height: 1.9;
  cursor: pointer;
}
.consent input {
  margin-top: 3px;
}
.consent a,
.notice a {
  text-decoration: underline;
  text-underline-offset: 3px;
}
.submit {
  width: 100%;
  min-height: 56px;
  padding: 16px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 18px;
  border: 1px solid var(--yo-ink);
  border-radius: var(--yo-radius);
  background: var(--yo-ink);
  color: white;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}
.submit:disabled {
  background: #e7e7e2;
  border-color: #e7e7e2;
  color: #716f68;
  cursor: default;
}
.submit:not(:disabled):hover {
  background: #383630;
}
.notice {
  margin: 0 0 24px;
  padding: 16px;
  background: #f8f6e9;
  color: #5d5429;
  font-size: 13px;
  line-height: 1.9;
}
.errorSummary {
  padding: 16px;
  margin-bottom: 24px;
  background: #fff1ee;
  color: #922b21;
  font-size: 13px;
  line-height: 1.8;
}
.errorSummary ul {
  padding-left: 20px;
  list-style: disc;
  margin-top: 8px;
}
.errorSummary a {
  text-decoration: underline;
}
.challenge {
  min-width: 0;
  font-size: 12px;
  line-height: 1.8;
  scroll-margin-top: 100px;
}
.challenge > p {
  margin-bottom: 12px;
}
.challenge a {
  text-decoration: underline;
}
.challenge:focus {
  outline: 3px solid #003cf0;
  outline-offset: 4px;
}
.honeypot {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
}
.success {
  scroll-margin-top: 100px;
}
.successIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  background: var(--yo-yellow);
  border-radius: var(--yo-radius);
  margin-bottom: 24px;
}
.success h2 {
  font-size: 26px;
  font-weight: 700;
  line-height: 1.6;
  margin: 12px 0 16px;
}
.success > p:not(.eyebrow) {
  font-size: 14px;
  line-height: 1.9;
}
.downloads {
  padding: 0;
  margin: 28px 0 20px;
  list-style: none;
}
.downloads a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 20px 0;
  border-bottom: 1px solid #deded8;
  font-size: 15px;
  font-weight: 700;
}
.downloads small {
  display: block;
  font-size: 11px;
  font-weight: 400;
  color: var(--yo-muted);
  margin-top: 8px;
}
.downloads svg {
  flex-shrink: 0;
}
.loading {
  min-height: 60vh;
  padding: 80px 24px;
  text-align: center;
}
.page :is(input, textarea, select, button, a, fieldset):focus-visible {
  outline: 3px solid #003cf0;
  outline-offset: 4px;
}
@media (max-width: 800px) {
  .layout {
    grid-template-columns: minmax(0, 1fr);
    max-width: 660px;
    padding: 24px 20px 64px;
    gap: 32px;
  }
  .intro {
    padding: 0;
  }
  .intro h1 {
    margin: 16px 0 24px;
  }
  .alternative {
    margin-top: 20px;
  }
}

.layout > :is(.form, .success) {
  grid-column: 2;
  grid-row: 1 / span 2;
}
.support {
  grid-column: 1;
  min-width: 0;
}
.support h2 {
  font-size: 17px;
  font-weight: 700;
  margin: 24px 0 8px;
}
.selectedMaterial {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.8;
  margin: 16px 0 0;
}
.materialPreview {
  margin: 0 0 28px;
}
.materialPreview img {
  width: 100%;
  height: auto;
}
.materialPreview figcaption {
  margin-top: 12px;
  font-size: 13px;
  line-height: 1.8;
}
.materialPreview strong,
.materialPreview span {
  display: block;
}
.materialPreview span {
  color: var(--yo-muted);
  font-size: 12px;
}
.materialPreview p {
  margin-top: 8px;
}
.optionalFields {
  padding-top: 12px;
}
.optionalFields summary {
  min-height: 44px;
  padding: 12px 0;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}
.optionalFields .field,
.optionalFields .choice {
  margin-top: 16px;
}
.optionalFields summary:focus-visible {
  outline: 2px solid var(--yo-ink);
  outline-offset: 3px;
}
@media (max-width: 800px) {
  .layout {
    grid-template-rows: auto;
    gap: 22px;
  }
  .intro h1 {
    margin: 10px 0 14px;
    font-size: 36px;
  }
  .intro .description {
    margin: 0;
    font-size: 14px;
    line-height: 1.8;
  }
  .intro .notice {
    margin: 12px 0 0;
    padding: 0;
    background: transparent;
    color: var(--yo-ink-2);
  }
  .layout > :is(.form, .success),
  .support {
    grid-column: 1;
    grid-row: auto;
  }
  .formHead {
    margin-bottom: 20px;
  }
  .formHead h2 {
    font-size: 18px;
  }
  .form {
    padding: 24px 20px;
  }
}

.compactPreview {
  display: grid;
  grid-template-columns: 112px 1fr;
  gap: 16px;
  margin: 24px 0 0;
  align-items: start;
}
.compactPreview > img {
  width: 112px;
  height: auto;
}
.compactPreview strong,
.compactPreview span {
  display: block;
}
.compactPreview strong {
  font-size: 14px;
  line-height: 1.6;
}
.compactPreview span,
.compactPreview p {
  font-size: 12px;
  line-height: 1.7;
  margin: 6px 0;
  color: #626269;
}
.insidePreview {
  grid-column: 1 / -1;
  font-size: 12px;
}
.insidePreview summary {
  min-height: 44px;
  padding-block: 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  text-underline-offset: 4px;
}
.insidePreview img {
  width: 100%;
  height: auto;
  margin: 16px 0 8px;
}

.form {
  scroll-margin-top: 88px;
}
.messagePrompts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.messageStarter {
  display: grid;
  gap: 4px;
}
.morePrompts summary {
  min-height: 44px;
  padding-block: 12px;
  color: var(--yo-ink-2);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.morePrompts[open] .messagePrompts {
  margin-bottom: 8px;
}
.morePrompts summary:focus-visible {
  outline: 2px solid var(--yo-ink);
  outline-offset: 3px;
}
.messagePrompts > span {
  width: 100%;
  color: var(--yo-muted);
  font-size: 12px;
}
.messagePrompts button {
  min-height: 44px;
  padding: 8px 12px;
  background: #fafaf8;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 150ms ease;
}
.messagePrompts button[aria-pressed="true"],
.messagePrompts button:hover {
  background: #fff3a6;
}
.messagePrompts button:disabled {
  cursor: default;
  opacity: 0.6;
}
@media (prefers-reduced-motion: reduce) {
  .messagePrompts button {
    transition: none;
  }
}

/* Standalone actions use spacing and weight; underline appears on interaction. */
.textLink:hover,
.insidePreview summary:hover {
  text-decoration: underline;
  text-underline-offset: 5px;
}

@media (max-width: 380px) {
  .layout {
    padding-inline: 16px;
  }
  .form,
  .success {
    padding: 20px 16px;
  }
  .compactPreview {
    grid-template-columns: 88px minmax(0, 1fr);
    gap: 12px;
  }
  .compactPreview > img {
    width: 88px;
  }
}

.promptPreview {
  padding: 16px;
  background: #fafaf8;
  font-size: 14px;
  line-height: 1.8;
}
.promptPreview p {
  margin: 0 0 8px;
}
.consentPolicy {
  display: block;
  font-size: 11px;
  font-weight: 400;
}

.estimateSummary {
  margin-bottom: 28px;
  padding-bottom: 24px;
  border-bottom: 1px solid var(--yo-line);
}
.carried {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 20px;
  font-size: 12px;
  font-weight: 600;
}
.carried svg {
  background: var(--yo-yellow);
  border-radius: 50%;
}
.estimateDetails {
  font-size: 12px;
  border-top: 1px solid var(--yo-line);
}
.estimateDetails summary {
  padding: 14px 0;
  cursor: pointer;
}
.estimateDetails dl {
  margin: 0;
}
.estimateDetails dl > div {
  display: grid;
  grid-template-columns: 80px minmax(0, 1fr);
  gap: 12px;
  padding: 6px 0;
}
.estimateDetails dt {
  color: var(--yo-muted);
}
.estimateDetails dd {
  margin: 0;
}
.brickIntro .lead {
  font-size: 22px;
}
